// Breadcrumb identifiers
const cronJobBreadcrumbIdentifier = {
    route: 'administrations.cron-jobs.edit',
    parameterLabel: 'cron_job',
    parameters: ['cron_job']
}

export default [
    {
        route: 'administrations.cron-jobs.index',
        label: 'messages.sitemap.administration.cron_jobs.cron_jobs',
        showInSidebar: true,
        permissions: ['admin.cronjobs'],
        id: 'administration-cron-jobs-index',
        children: [
            {
                route: 'administrations.cron-jobs.executions',
                label: 'messages.sitemap.administration.cron_jobs.executions',
                activeSidebarRoute: 'administrations.cron-jobs.index'
            },
            {
                route: 'administrations.cron-jobs.create',
                label: 'messages.sitemap.administration.cron_jobs.create'
            },
            {
                route: 'administrations.cron-jobs.edit',
                label: 'messages.sitemap.administration.cron_jobs.edit',
                identifier: cronJobBreadcrumbIdentifier
            }
        ]
    },
    {
        route: 'administrations.sanity-checks.index',
        label: 'messages.sitemap.administration.sanity_checks.sanity_checks',
        showInSidebar: true,
        permissions: ['admin.sanity_checks'],
        id: 'administration-sanity-checks-index',
        children: []
    },
    {
        route: '',
        label: 'messages.sitemap.administration.queue_jobs.queue',
        showInSidebar: true,
        permissions: ['queue.monitoring'],
        showSecondDropdown: true,
        sidebarItemName: 'Queues',
        id: 'administrations-queues',
        children: [
            {
                route: 'administrations.queue.index',
                label: 'messages.sitemap.administration.queue_jobs.queue_jobs',
                showInSidebar: true,
                permissions: ['queue.monitoring'],
                id: 'administration-queue-jobs-index'
            },
            {
                route: 'administrations.queue.worker-settings',
                label: 'messages.sitemap.administration.queue_management.worker_settings',
                showInSidebar: true,
                permissions: ['queue.management'],
                id: 'administration-queue-worker-settings'
            }
        ]
    }
]
